import * as React from "react";
import { cn } from "@/lib/cn";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

/**
 * Textarea — Volume 03 §3. Min-height 96px, resize dọc.
 */
export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, "aria-invalid": ariaInvalid, ...props }, ref) => (
    <textarea
      ref={ref}
      aria-invalid={ariaInvalid ?? (invalid ? true : undefined)}
      className={cn(
        "min-h-[96px] w-full resize-y rounded-md border bg-surface px-3.5 py-2.5 text-body text-foreground",
        "placeholder:text-disabled transition-colors duration-fast ease-out",
        "focus-visible:outline-none focus-visible:ring focus-visible:ring-ring focus-visible:border-primary",
        "disabled:cursor-not-allowed disabled:bg-subtle disabled:text-disabled",
        invalid ? "border-danger focus-visible:border-danger focus-visible:ring-danger/40" : "border-border-strong",
        className
      )}
      {...props}
    />
  )
);
Textarea.displayName = "Textarea";
